var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            { attrs: { md3: "" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.$t("organizationName"),
                  items: _vm.tenantWorkFor,
                  "item-text": "tenantName",
                  "return-object": ""
                },
                model: {
                  value: _vm.selectedTenant,
                  callback: function($$v) {
                    _vm.selectedTenant = $$v
                  },
                  expression: "selectedTenant"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs8: "", md3: "", lg2: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "filter_list",
                  label: _vm.$t("search"),
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "justify-start": "", "align-baseline": "" } },
        [
          _c("v-flex", { staticClass: "success--text caption" }, [
            _c("span", { staticClass: "realtime-border px-1" }, [
              _vm._v(_vm._s(_vm.$t("realTIME")))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-data-table",
        {
          staticClass: "elevation-2 myDense",
          attrs: {
            headers: _vm.headers,
            items: _vm.products,
            search: _vm.filter,
            pagination: _vm.pagination,
            "rows-per-page-items": _vm.rowPerPage
          },
          on: {
            "update:pagination": function($event) {
              _vm.pagination = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "items",
              fn: function(props) {
                return [
                  _c("td", { staticClass: "subheading" }, [
                    _vm._v(_vm._s(props.index + 1))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-xs-left" }, [
                    _vm._v(_vm._s(_vm.selectedTenant.tenantName))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-xs-left" }, [
                    _vm._v(
                      _vm._s(props.item.productCondition) +
                        " - " +
                        _vm._s(props.item.productName)
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-xs-left" }, [
                    _vm._v(_vm._s(props.item.upc))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-xs-left" }, [
                    _vm._v(_vm._s(props.item.quantity))
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-right" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    dark: "",
                                    color: "primary",
                                    flat: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showProductDetail(props.item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("detail")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c("v-progress-linear", {
            attrs: { color: "blue", indeterminate: "" },
            scopedSlots: _vm._u([
              {
                key: "progress",
                fn: function() {
                  return undefined
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("SimpleTextPopup", {
        attrs: { title: _vm.$t("productDetails"), hideRgtBtn: "", medium: "" },
        on: {
          popupClose: function($event) {
            _vm.productDetailDialog = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _vm.selectedProduct
                  ? _c(
                      "v-container",
                      [
                        _c(
                          "v-layout",
                          [
                            _c("v-flex", [
                              _c(
                                "span",
                                { staticClass: "font-gray font-theme" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedProduct.productCondition
                                    ) + " - "
                                  )
                                ]
                              ),
                              _c("span", { staticClass: "font-theme" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.selectedProduct.productName)
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs8: "", md3: "", lg2: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "append-icon": "filter_list",
                                    label: _vm.$t("search"),
                                    "single-line": "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.dialogFilter,
                                    callback: function($$v) {
                                      _vm.dialogFilter = $$v
                                    },
                                    expression: "dialogFilter"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider"),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { column: "" } },
                          [
                            _c("v-data-table", {
                              staticClass: "elevation-2 myDense",
                              attrs: {
                                headers: _vm.detailHeaders,
                                items: _vm.productDistribution,
                                "item-key": "key",
                                search: _vm.dialogFilter,
                                pagination: _vm.pagination,
                                "rows-per-page-items": _vm.rowPerPage
                              },
                              on: {
                                "update:pagination": function($event) {
                                  _vm.pagination = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "subheading" },
                                          [_vm._v(_vm._s(props.index + 1))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.warehouseSite)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.quantity))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { color: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showReportMissingDetail(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.$t("report")))]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2140341438
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.productDetailDialog,
          callback: function($$v) {
            _vm.productDetailDialog = $$v
          },
          expression: "productDetailDialog"
        }
      }),
      _vm._v(" "),
      _vm.reportMissingDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("reportMissingItems"),
              rightMethod: _vm.reportLost,
              rightButtonText: _vm.$t("report"),
              medium: ""
            },
            on: {
              popupClose: function($event) {
                _vm.reportMissingDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-layout",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("product"),
                              "prepend-icon": "shopping_cart",
                              disabled: ""
                            },
                            model: {
                              value: _vm.report.productName,
                              callback: function($$v) {
                                _vm.$set(_vm.report, "productName", $$v)
                              },
                              expression: "report.productName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-text-field", {
                            staticClass: "required_field",
                            attrs: {
                              label: _vm.$t("quantity"),
                              "prepend-icon": "event",
                              rules: [
                                _vm.checkQuantity,
                                _vm.fieldIsRequired("Quantity"),
                                _vm.fieldIsOverZero("quantity"),
                                _vm.fieldIsInteger("Quantity")
                              ]
                            },
                            model: {
                              value: _vm.report.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.report, "quantity", _vm._n($$v))
                              },
                              expression: "report.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("site"),
                              "prepend-icon": "local_shipping",
                              disabled: ""
                            },
                            model: {
                              value: _vm.report.warehouseSite,
                              callback: function($$v) {
                                _vm.$set(_vm.report, "warehouseSite", $$v)
                              },
                              expression: "report.warehouseSite"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3845236143
            ),
            model: {
              value: _vm.reportMissingDialog,
              callback: function($$v) {
                _vm.reportMissingDialog = $$v
              },
              expression: "reportMissingDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f97d1872", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f97d1872","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InventoryUser.vue
// module id = null
// module chunks = 